import React, { useContext, useState } from 'react';
import { Modal, Box, Typography, IconButton, Button, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PaymentIcon from '@mui/icons-material/Payment'; // UPI icon placeholder
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AuthContext from '../store/AuthContext';
import { okSuccessToast } from '../utils/ToastUtil';

const UpiGatewayComponent = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authCtx=useContext(AuthContext);
  const user=authCtx.user;

  // const paymentUrl = `https://localhost:3000/upi/payment?id=${user.id}&name=${user.establishment}`;

  const paymentUrl = `https://dillipay.com/upi/payment?id=${user.id}&name=${user.establishment}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentUrl);
    okSuccessToast('URL copied to clipboard!');
  };

  const handleOpenLink = () => {
    window.open(paymentUrl, '_blank');
  };

  return (
    <>
       <IconButton onClick={handleOpen} sx={{ display: "contents" }}>
        <Tooltip title="QR 2" placement="top">
          <PaymentIcon
            className="hover-white hover-zoom"
            size="1.3rem"
            sx={{ color: "#D53E3E", fontWeight: "bold" }}
          />
        </Tooltip>
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            width: 400,
          }}
        >
          <Typography variant="h6" mb={2}>
            Payment Link
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
            {paymentUrl}
          </Typography>

          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={handleCopy}>
              Copy
            </Button>
            <Button variant="contained" endIcon={<OpenInNewIcon />} onClick={handleOpenLink}>
              Open
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default UpiGatewayComponent;
